import { Injectable } from '@angular/core';

import { AbstractSecurityStorage } from 'angular-auth-oidc-client';

@Injectable({
	providedIn: 'root',
})
export class SessionStorageStorageService implements AbstractSecurityStorage {
	read(key: string) {
		return sessionStorage.getItem(key);
	}

	write(key: string, value: any): void {
		sessionStorage.setItem(key, value);
	}

	remove(key: string): void {
		sessionStorage.removeItem(key);
	}

	clear(): void {
		sessionStorage.clear();
	}
}
